module.exports = __webpack_public_path__ + "static/behind-the-beautiful-forevers-445ebef5381faecbb73624dd45003bfe.jpg";